<template>
  <div class="home">
    <component :is="component" v-if="component"/>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    component() {
      return () => import(`@/views/member/Member`)
    }
  },
  methods: {},
  watch: {},
}
</script>
